module.exports = __webpack_public_path__ + "@/assets/img/position.ebaf64b3.svg";